import { eventosTypes } from '../constantes/actionTypes'

const initialState = []

export const eventos = (state = initialState, action) => {
  switch (action.type) {
    case eventosTypes.GET_ALL_EVENTOS_SUCCESS:
      return action.payload
    case eventosTypes.GET_ALL_EVENTOS_FAILURE:
      return initialState
    case eventosTypes.DELETE_EVENTO_SUCCESS:
      return state.filter((evento) => evento.id_Evento !== action.payload)
    case eventosTypes.DELETE_EVENTO_FAILURE:
      return state
    default:
      return state
  }
}
